"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import { FocusableStyles } from "../../vfx";
import styles from "./card.module.css";
export var CardStyles = styles;
export function Card(_a) {
    var _b;
    var className = _a.className, imageClassName = _a.imageClassName, contentClassName = _a.contentClassName, metaClassName = _a.metaClassName, children = _a.children, elevation = _a.elevation, _c = _a.borderRadius, borderRadius = _c === void 0 ? "md" : _c, focusable = _a.focusable, focused = _a.focused, breathing = _a.breathing, error = _a.error, _d = _a.showBorder, showBorder = _d === void 0 ? true : _d, image = _a.image, meta = _a.meta, _e = _a.stackMobile, stackMobile = _e === void 0 ? false : _e, rest = __rest(_a, ["className", "imageClassName", "contentClassName", "metaClassName", "children", "elevation", "borderRadius", "focusable", "focused", "breathing", "error", "showBorder", "image", "meta", "stackMobile"]);
    return (_jsxs("div", __assign({}, rest, { className: classNames(styles["card"], className, (_b = {},
            _b[styles["elevate-1"]] = elevation === 1,
            _b[styles["elevate-2"]] = elevation === 2,
            _b[styles["elevate-3"]] = elevation === 3,
            _b[styles["elevate-4"]] = elevation === 4,
            _b[styles["border-radius-sm"]] = borderRadius === "sm",
            _b[styles["elevate-1"]] = elevation === 1,
            _b[styles["elevate-2"]] = elevation === 2,
            _b[styles["elevate-3"]] = elevation === 3,
            _b[styles["elevate-4"]] = elevation === 4,
            _b[styles["border-radius-sm"]] = borderRadius === "sm",
            _b[styles["border-radius-md"]] = borderRadius === "md",
            _b[styles["border-radius-lg"]] = borderRadius === "lg",
            _b[styles["border"]] = showBorder,
            _b[styles["has-image"]] = !!image,
            _b[styles["has-meta"]] = !!meta,
            _b[styles["stack-mobile"]] = !!stackMobile,
            _b[FocusableStyles["focusable"]] = focusable,
            _b[FocusableStyles["focused"]] = focused,
            _b[FocusableStyles["breathing"]] = breathing,
            _b[FocusableStyles["error"]] = error,
            _b)), children: [image && (_jsx("div", { className: classNames(styles["image"], imageClassName), children: image })), !!image || !!meta ? (_jsx("div", { className: classNames(styles["content"], contentClassName), children: children })) : (_jsx("div", { className: classNames(styles["content"], contentClassName), children: children })), meta && (_jsx("div", { className: classNames(styles["meta"], metaClassName), children: meta }))] })));
}
export default Card;
